import { SVGProps } from 'react';

const SvgCheckCircleOutline = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333Zm0 12A5.34 5.34 0 0 1 2.667 8 5.34 5.34 0 0 1 8 2.667 5.34 5.34 0 0 1 13.333 8 5.34 5.34 0 0 1 8 13.333Zm3.06-8.28L6.667 9.447 4.94 7.727l-.94.94 2.667 2.666L12 6l-.94-.947Z" />
    </svg>
);
export default SvgCheckCircleOutline;
